var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBasketShowAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 16.875C4.375 17.9088 5.21625 18.75 6.25 18.75C7.28375 18.75 8.125 17.9088 8.125 16.875C8.125 15.8412 7.28375 15 6.25 15C5.21625 15 4.375 15.8412 4.375 16.875ZM6.875 16.875C6.875 17.2194 6.59437 17.5 6.25 17.5C5.90562 17.5 5.625 17.2194 5.625 16.875C5.625 16.5306 5.90562 16.25 6.25 16.25C6.59437 16.25 6.875 16.5306 6.875 16.875Z",
    fill: "#F2C94C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 16.875C15.625 15.8412 14.7838 15 13.75 15C12.7162 15 11.875 15.8412 11.875 16.875C11.875 17.9088 12.7162 18.75 13.75 18.75C14.7838 18.75 15.625 17.9088 15.625 16.875ZM13.125 16.875C13.125 16.5306 13.4056 16.25 13.75 16.25C14.0944 16.25 14.375 16.5306 14.375 16.875C14.375 17.2194 14.0944 17.5 13.75 17.5C13.4056 17.5 13.125 17.2194 13.125 16.875Z",
    fill: "#F2C94C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5625 1.875C2.64 2.61312 3.5025 10.8056 3.63562 12.0712C3.73625 13.0281 4.53812 13.75 5.50062 13.75H15.24C16.1181 13.75 16.8894 13.1263 17.0737 12.2675L18.575 5.26187C18.6544 4.89062 18.5631 4.50875 18.3244 4.21438C18.0856 3.91937 17.7313 3.75 17.3519 3.75H4.01688L3.74687 1.185C3.71312 0.86625 3.445 0.625 3.125 0.625H1.25C0.905 0.625 0.625 0.905 0.625 1.25C0.625 1.595 0.905 1.875 1.25 1.875H2.5625ZM17.3519 5L15.8512 12.0056C15.7894 12.2919 15.5325 12.5 15.2394 12.5H5.50062C5.17937 12.5 4.9125 12.2594 4.87875 11.9406L4.14813 5H17.3519Z",
    fill: "#F2C94C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBasketShowAccount);
export default __webpack_public_path__ + "static/media/icon-basket-show-account.80c4645cafc08b95500e090999293ca9.svg";
export { ForwardRef as ReactComponent };